module.exports = __webpack_public_path__ + "static/img/6.3800a19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/裤子/6.png
// module id = C1VE
// module chunks = 0